import Lazy from '../modules/lazy';

class PostsGrid {
  scroll = Math.abs(window.scrollY);

  constructor() {
    const roots = document.querySelectorAll('.posts-grid');

    roots.forEach(root => {
      const items = root.querySelector('.posts-grid__items');
      const button = root.querySelector('.posts-grid__button');

      let page = 2;

      if (page > button.dataset.pages) {
        button.classList.add('hidden');
      }

      button?.addEventListener('click', async () => {
        const data = await this.get_posts(page, button.dataset.category);

        page++;

        if (page > button.dataset.pages) {
          button.classList.add('hidden');
        }

        items.innerHTML = items.innerHTML + data;

        window.scrollTo({
          top: this.scroll,
          behavior: 'instant',
        });

        new Lazy;
      });
    });

    this.handleScroll();
    window.addEventListener('scroll', () => this.handleScroll());
  }

  get_posts = async (page, category) => {
    const resp = await fetch(`/wp-admin/admin-ajax.php?action=get_posts_grid_items&page=${page}&category=${category}`);
    const data = await resp.text();

    return data;
  }

  handleScroll() {
    this.scroll = Math.abs(window.scrollY);
  }
}

export default PostsGrid;
